import type { AccountFormutil, CategoryFormutil } from 'modules/Open';
import { UploadPathType } from 'types/common';
import {
    AccountProcessDataType,
    CategoryEnum,
    CustomerTypeEnum,
    IdTypeEnum,
    OpenType,
    ProcessMissingTypeEnum
} from 'types/customer';

// 链接上的query参数是字符串, 需要转换为对应的枚举类型(数字枚举)
const customerTypeMap: Record<string, CustomerTypeEnum> = {
    [`${CustomerTypeEnum.INDIVIDUAL}`]: CustomerTypeEnum.INDIVIDUAL,
    [`${CustomerTypeEnum.IRA_ROLLOVER}`]: CustomerTypeEnum.IRA_ROLLOVER,
    [`${CustomerTypeEnum.IRA_ROTH}`]: CustomerTypeEnum.IRA_ROTH,
    [`${CustomerTypeEnum.IRA_TRADITIONAL}`]: CustomerTypeEnum.IRA_TRADITIONAL
};

export function getAccountParamsByQuery(
    queryCategory: string | null,
    queryCustomerType: string | null
): {
    category: Partial<CategoryFormutil> | undefined;
    account: Partial<AccountFormutil> | undefined;
} {
    let accountParams: Partial<AccountFormutil> | undefined = undefined;
    let categoryParams: Partial<CategoryFormutil> | undefined = undefined;
    /**
     * 注意这里首先判断了链接上是否存在, 而没有直接使用Number进行转换, 是因为customerType如果为0的话是有实际意义的, 但是Number(null)的结果也是0
     * 所以不能直接转换, 要先判断是否存在
     */
    const numQueryCustomerType = queryCustomerType ? customerTypeMap[queryCustomerType] : null;

    // 如果缓存中没有账户信息数据, 则根据链接上的query初始化账户信息
    if (queryCategory) {
        // 如果链接上拼上的category参数是那么直接进入Individual, 那么直接进入Individual的流程
        if (queryCategory === CategoryEnum.INDIVIDUAL) {
            // Individual形式会跳向账户选择页面, 在账户选择页面会决定是否是ssn
            accountParams = {
                temporaryOpenType: OpenType.INDIVIDUAL
            };

            categoryParams = {
                category: CategoryEnum.INDIVIDUAL
            };

            // 如果链接上拼上的category参数是IRA, 且带有customerType, 且在支持的范围中, 那么直接进入IRA的流程
        } else if (
            queryCategory === CategoryEnum.IRA &&
            numQueryCustomerType !== null &&
            CustomerTypeEnum[numQueryCustomerType]
        ) {
            accountParams = {
                customer_type: numQueryCustomerType,
                temporaryOpenType: OpenType.IRA,
                // ira账户默认是SSN
                id_type: IdTypeEnum.SSN_IDS
            };

            categoryParams = {
                category: CategoryEnum.IRA
            };
        }
    }

    return {
        account: accountParams,
        category: categoryParams
    };
}

/**
 * @description Continue状态证件上传模块的默认路径，但目前美国开户Continue状态不需要补充证件，只有一个大客户确认资料
 */
const uploadPathMap: Record<ProcessMissingTypeEnum, UploadPathType> = {
    [ProcessMissingTypeEnum.ASSISTED_OPENING_ACK]: 'confirm'
};

/**
 * @description 获取开户中证件上传模块的默认路径
 */
export function getDefaultUploadPath(processMissing?: AccountProcessDataType['missing']): UploadPathType | undefined {
    // 没有missing数据的时候应该返回空值
    if (!processMissing?.length) {
        return undefined;
    }

    const firstMissing = processMissing[0];

    return uploadPathMap[firstMissing.type];
}
